import cookieBar from "./cookiebar";
import disableImageRightClick from "./disable-image-right-click";
import fadeIn from "./fade-in";
import gallery from "./gallery";
import loadMore from "./load-more";
import nav from "./nav";
import rail from "./rail";
import video from "./video";
import initMaps from "./init-maps";
import initAccordion from "./accordion";

document.addEventListener("DOMContentLoaded", () => {
  cookieBar();
  fadeIn();
  gallery();
  loadMore();
  nav();
  rail();
  video();
  disableImageRightClick();
  initMaps();
  initAccordion();
});
